import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
  import Modal from "./Modal.vue";
  import { ref } from "vue";
  import { useToast } from "vue-toastification";
  import { EoiInterface } from "@/types/EoiInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectReiTemplate',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
    },
    eoi: {
      type: Object as () => EoiInterface,
      required: true,
    },
  },
  emits: ["close", "success"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const toast = useToast();
  const emits = __emit;

  const loading = ref<boolean>(false);
  const redirectUrl = ref<string>("");
  const formName = ref<string>("");

  const close = () => {
    loading.value = false;
    emits("close");
  };

  const goToPreview = () => {
    window.open(redirectUrl.value, "_blank");
  };

  const resetForm = () => {
    redirectUrl.value = "";
  };

  const onSubmit = async () => {
    loading.value = true;
    store
      .dispatch("rei/createForm", {
        template_id: "511",
        name: formName.value,
        eoi: {
          buyersData: { ...props.eoi.buyersData },
          conveyancerDetails: props.eoi.conveyancerDetails,
          isZeroDeposit: props.eoi.isZeroDeposit,
          estate: {
            id: props.eoi.estateId?._id,
            address: props.eoi.estateId?.address,
            initDeposit: props.eoi.estateId?.initDeposit,
            title: props.eoi.estateId?.title,
          },
          lot: {
            id: props.eoi.lotId._id,
            size: props.eoi.lotId.size,
            title: props.eoi.lotId.title,
            price: props.eoi.lotId.price,
            financeDueDate: props.eoi.lotId.financeDueDate,
          },
        },
      })
      .then((res) => {
        redirectUrl.value = res.data;
      })
      .catch((err) => {
        toast.error("Something went wrong");
      })
      .finally(() => {
        loading.value = false;
      });
  };

const __returned__ = { props, toast, emits, loading, redirectUrl, formName, close, goToPreview, resetForm, onSubmit, get store() { return store }, Modal, ref, get useToast() { return useToast }, get EoiInterface() { return EoiInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})